import * as React from 'react';
import { UserState } from 'app/reducers/state';
import { Button, Callout, Intent, Spinner } from '@blueprintjs/core';
import { executeQueryGetAuth } from 'app/utils/api';

const NO_CERT_MESSAGE = "You did not purchase a vLeader certificate with your license";

interface Props {
    user: UserState;
    targetUserID?: string;
};

interface State {
    loadingAllData: boolean;
    allData: GameData[];
    certData: any;
    ownsCert: boolean;
}

interface GameData {
    scenario: string;
    results: string;
}

export class CertificateViewUser extends React.Component<Props, State> {
    state: State = {
        loadingAllData: true,
        allData: [],
        certData: undefined,
        ownsCert: false
    }

    componentDidMount() {
        this.initiData();
    }

    initiData = () => {
        executeQueryGetAuth(`certificates/v2/${this.getUserID()}`, {}, this.props.user, (data) => {
            executeQueryGetAuth(`users/${this.getUserID()}`, {}, this.props.user, (userData) => {
                this.setState({
                    certData: data.body,
                    loadingAllData: false,
                    ownsCert: userData.body.certificate === "1" || userData.body.certificate === 1
                });
            });
            
        });
    }

    getUserID = () => {
		const {
			targetUserID,
			user
		} = this.props;

		if (targetUserID !== undefined) {
			return targetUserID;
		}

		return user.id;
	}

	render() {
        const {
            certData,
            loadingAllData,
            ownsCert
        } = this.state;

        const userHasCertificate = ownsCert;

        if (loadingAllData) {
            return <span>
                <p style={{textAlign: 'center', paddingBottom: '10px'}}>Your scores are being calculated....</p>
                <Spinner />
            </span>
        }

        if (userHasCertificate === false) {
            return <span>
                <Callout intent={Intent.DANGER}>
                    {NO_CERT_MESSAGE}
                </Callout>
            </span>
        }

        const hasCert = !(certData['dl'] === undefined || certData['dl'] === null || certData['dl'] === '');

        return <span>
            {hasCert ? <Callout intent={Intent.PRIMARY}>
                
                <h4>Congratulations!</h4>
                <p>You've taken one very important step in your long journey to personal success.</p>
                <p>Certificate Level Achieved: <strong>{certData['level']}</strong> </p><br />
                <Button text="Download Certificate" onClick={() => {
                    window.open(certData['dl'], "_blank");
                }} />
            </Callout> : <Callout intent={Intent.PRIMARY}>
                Unfortunately you did not receive a certificate.
            </Callout>}
        </span>
	}
}
